import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconForwardProps } from './IconForward.types'
import * as Styled from './styles/IconForward.style'

import { nonThemeableRules } from '../../ruleSet'

const IconForward: FC<IconForwardProps> = ({
  size = nonThemeableRules.defaultSize as number as IconForwardProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconForwardProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M20.39 11.926V12c-.042.406-.218.79-.492 1.09l-1.238 1.285-2.687 2.8a.82.82 0 0 1-1.407-.562v-.488a.754.754 0 0 0 0-.133c-.062-.492-.398-.828-1-.867-2.75-.184-5.613.25-8.027 1.625-.418.234-.828.496-1.25.734a.5.5 0 0 1-.726-.597c.949-2.801 2.445-4.676 4.035-5.926 2.16-1.7 4.488-2.211 5.843-2.254.485-.012 1.02-.36 1.11-.832a1.73 1.73 0 0 0 .023-.2v-.448a.794.794 0 0 1 .781-.817h.055a.8.8 0 0 1 .567.25l2.043 2.074 1.886 1.91.074.086c.22.278.36.61.403.961.008.079.012.157.008.235Zm0 0'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconForward
